import { Routes, RouterModule } from '@angular/router';

const appRoutes: Routes = [
  // otherwise redirect to home
  //{ path: '**', redirectTo: '' },
];

export const AppRouting = RouterModule.forRoot(appRoutes, {
  paramsInheritanceStrategy: 'always',
});
